import React from 'react'
import PropTypes from 'prop-types'
import { useAuth0 } from '@auth0/auth0-react'
import { domains } from '../../lib/config'
import AuthZeroErrorMessage from '../AuthZeroErrorMessage'
import {
  CopyrightIcon,
  ErrorDetail,
  ErrorContainer,
  ErrorHeader,
  ErrorMessage,
  ErrorPage,
  Footer,
  FooterLink,
  FooterLinks,
  FooterLogo,
  FooterTerms,
  FooterText,
  HelpContainer,
  HelpList,
  HelpListItem,
  HelpMessage,
  HelpText,
  Hr,
  LogoutLink,
  SecondStepLogo,
  SecondStepLogoLink,
  UnableToAuthenticateContainer,
} from './component.styles'
import {
  ABOUT_US,
  CFC_NAME,
  CURRENT_YEAR,
  HELP,
  LOG_OUT,
  PRIVACY_POLICY,
  SS_MESSAGE,
  START_YEAR,
  TERMS_OF_USE,
  VERIFICATION_NEEDED_HEADER,
  VERIFICATION_NEEDED_MESSAGE,
  VERIFICATION_HELP_HEADER,
  VERIFICATION_HELP_ITEMS,
} from './constants'

function Auth0ErrorHandler(props) {
  const { children } = props
  const { error, logout } = useAuth0()
  const isUnauthorized = error && error.error === 'unauthorized'

  return (
    <React.Fragment>
      {error ? (
        <React.Fragment>
          <ErrorPage>
            <SecondStepLogoLink href="https://www.secondstep.org/">
              <SecondStepLogo
                alt="Second Step logo"
                src={`${domains.CDN_DOMAIN}/assets/img/login/secondstep-logo.svg`}
              />
            </SecondStepLogoLink>
            {!isUnauthorized && (
              <UnableToAuthenticateContainer>
                <AuthZeroErrorMessage
                  error={error}
                  logOut={() => logout({ returnTo: window.location.origin })}
                />
              </UnableToAuthenticateContainer>
            )}
            {isUnauthorized && (
              <React.Fragment>
                <ErrorContainer>
                  <ErrorHeader data-testid="auth-error-header">
                    {VERIFICATION_NEEDED_HEADER}
                  </ErrorHeader>
                  <Hr />
                  <ErrorMessage>
                    {VERIFICATION_NEEDED_MESSAGE}
                    <ErrorDetail>{error.message}</ErrorDetail>
                  </ErrorMessage>
                  <HelpContainer>
                    <HelpMessage>{VERIFICATION_HELP_HEADER}</HelpMessage>
                    <HelpList>
                      {VERIFICATION_HELP_ITEMS.map((helpItem, index) => (
                        <HelpListItem key={index}>
                          <HelpText>{helpItem}</HelpText>
                        </HelpListItem>
                      ))}
                    </HelpList>
                  </HelpContainer>
                  <LogoutLink
                    onClick={() =>
                      logout({ returnTo: domains.PUBLIC_SITE_DOMAIN })
                    }
                  >
                    {LOG_OUT}
                  </LogoutLink>
                </ErrorContainer>
                <Footer>
                  <FooterTerms>
                    <FooterText>
                      <span>
                        <CopyrightIcon>©</CopyrightIcon>
                        {`${START_YEAR}-${CURRENT_YEAR} ${CFC_NAME}`}
                      </span>
                    </FooterText>
                    <FooterText>
                      <span> {SS_MESSAGE}</span>
                    </FooterText>
                    <FooterLinks>
                      <FooterLink href="https://www.secondstep.org/about-us/">
                        {ABOUT_US}
                      </FooterLink>
                      |
                      <FooterLink href="https://support.secondstep.org/hc/en-us/">
                        {HELP}
                      </FooterLink>
                      |
                      <FooterLink href="https://www.secondstep.org/privacy-policy/">
                        {PRIVACY_POLICY}
                      </FooterLink>
                      |
                      <FooterLink href="//www.secondstep.org/terms-of-use/">
                        {TERMS_OF_USE}
                      </FooterLink>
                    </FooterLinks>
                  </FooterTerms>
                  <FooterLogo
                    alt="Committee for Children logo"
                    src={`${domains.CDN_DOMAIN}/assets/img/login/cfc-logo.svg`}
                  />
                </Footer>
              </React.Fragment>
            )}
          </ErrorPage>
        </React.Fragment>
      ) : (
        <div>{children}</div>
      )}
    </React.Fragment>
  )
}

Auth0ErrorHandler.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
}

export default Auth0ErrorHandler



// WEBPACK FOOTER //
// ./src/components/Auth0ErrorHandler/component.jsx